import React from "react";
import { IconType } from "react-icons";

interface IconProps {
  icon: IconType;
  size?: number | string;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
  onClick?: () => void;
  "aria-hidden"?: boolean;
  "aria-label"?: string;
}

/**
 * Universal Icon wrapper to handle TypeScript issues with react-icons
 * This component ensures all react-icons are rendered correctly as JSX elements
 */
export const Icon: React.FC<IconProps> = ({
  icon: IconComponent,
  ...props
}) => {
  return React.createElement(IconComponent as React.ComponentType<any>, props);
};

export default Icon;
